// A line's amount is Quantity x Rate, except for lines billed by duration (Hours, Days, Weeks,
// Months, Years): there the rate is the price for the whole period and the quantity is only the
// length of that period. IT Consulting at 40,000 for 11 Months is 40,000, not 4,40,000.

const DURATION_UNIT = /^(hours?|hrs?|days?|weeks?|wks?|months?|mos?|years?|yrs?)$/i

export function isDurationUnit(unit: string | null | undefined): boolean {
  return DURATION_UNIT.test(String(unit ?? '').trim())
}

/** The line amount before discount and tax. */
export function lineGross(quantity: number | string | null | undefined, rate: number | string | null | undefined, unit?: string | null): number {
  const q = Number(quantity) || 0
  const r = Number(rate) || 0
  return isDurationUnit(unit) && q > 0 ? r : q * r
}
